module.exports = __webpack_public_path__ + "img/logo_secogey2.74939d98.jpg";